import { Booking } from "../../../../interface/Booking";
import styles from "./styles.module.css";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { className } from "../../../../utils/styles";
import { useContext } from "react";
import { BookingCalendarContext } from "../../../../context/BookingCalendarContext";
import { Button } from "../../../../components/Button";

type Props = {
  booking: Booking;
};

export const BookingPreview = ({ booking }: Props) => {
  const { t } = useTranslation();
  const { redirectUrl } = useContext(BookingCalendarContext);

  const staffName = `${booking.staff.first_name} ${booking.staff.last_name}`;
  return (
    <div className={styles.container}>
      <span className={styles.time}>
        {DateTime.fromISO(booking.start_time).toLocaleString(
          DateTime.TIME_24_SIMPLE,
        )}
      </span>
      <div className={styles.location}>
        <span className={styles.name}>{booking.name}</span>
        <span>{booking.location}</span>
      </div>
      <span className={styles.duration}>
        {t("booking_preview.duration", { minutes: booking.duration_mins })}
      </span>
      <div className={styles.staff}>
        {booking.staff.photo_url && (
          <img
            className={styles.staffImage}
            src={booking.staff.photo_url}
            alt={staffName}
          />
        )}
        <span
          className={className([
            booking.staff.photo_url
              ? styles.staffNameWithImage
              : styles.staffNameWithoutImage,
          ])}
        >
          {staffName}
        </span>
      </div>
      <Button className={styles.button} href={redirectUrl}>
        {t("booking_preview.book")}
      </Button>
    </div>
  );
};
